export default {
  label: {
    yAxisTitle: 'Publications',
  },
};
